import React, {Component} from "react";

/**
 * @props onClick - событие нажатия.
 */

class ImageViewer extends Component {

    render() {
        return <div
            style={{
                position: "fixed",
                width: "100%",
                height: "100%",
                left: "0px",
                top: "0px",
                backgroundColor: "rgb(0, 0, 0, 0.25)",
                zIndex: "1000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
            onClick={e=>{
                e.stopPropagation()
                if (typeof this.props.onClick === "function") {
                    this.props.onClick()
                }
            }}
        >
            <img 
                src={this.props.image}
                style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                }}                
            />
        </div>
    }

}

export default ImageViewer